var map = {
	"./AdminFavourites.vue": "./src/modules/shop/src/views/AdminFavourites.vue",
	"./AdminOrders.vue": "./src/modules/shop/src/views/AdminOrders.vue",
	"./AdminStockItemAlternatives.vue": "./src/modules/shop/src/views/AdminStockItemAlternatives.vue",
	"./Cart.vue": "./src/modules/shop/src/views/Cart.vue",
	"./CustomerCare.vue": "./src/modules/shop/src/views/CustomerCare.vue",
	"./Deliveries.vue": "./src/modules/shop/src/views/Deliveries.vue",
	"./EditCategory.vue": "./src/modules/shop/src/views/EditCategory.vue",
	"./EditCostCentre.vue": "./src/modules/shop/src/views/EditCostCentre.vue",
	"./EditCustomerLocation.vue": "./src/modules/shop/src/views/EditCustomerLocation.vue",
	"./EditDelivery.vue": "./src/modules/shop/src/views/EditDelivery.vue",
	"./EditDeliveryDate.vue": "./src/modules/shop/src/views/EditDeliveryDate.vue",
	"./EditDivision.vue": "./src/modules/shop/src/views/EditDivision.vue",
	"./EditEmail.vue": "./src/modules/shop/src/views/EditEmail.vue",
	"./EditEmailLog.vue": "./src/modules/shop/src/views/EditEmailLog.vue",
	"./EditPickingList.vue": "./src/modules/shop/src/views/EditPickingList.vue",
	"./EditPickingListItem.vue": "./src/modules/shop/src/views/EditPickingListItem.vue",
	"./EditPreferredDeliveryAddress.vue": "./src/modules/shop/src/views/EditPreferredDeliveryAddress.vue",
	"./EditPurchaseLimit.vue": "./src/modules/shop/src/views/EditPurchaseLimit.vue",
	"./EditQuote.vue": "./src/modules/shop/src/views/EditQuote.vue",
	"./EditRestaurantAdmin.vue": "./src/modules/shop/src/views/EditRestaurantAdmin.vue",
	"./EditSoftSaleStockItem.vue": "./src/modules/shop/src/views/EditSoftSaleStockItem.vue",
	"./EditStockItem.vue": "./src/modules/shop/src/views/EditStockItem.vue",
	"./EditStockItemAlternative.vue": "./src/modules/shop/src/views/EditStockItemAlternative.vue",
	"./EditSupplier.vue": "./src/modules/shop/src/views/EditSupplier.vue",
	"./Favourites.vue": "./src/modules/shop/src/views/Favourites.vue",
	"./ListCategory.vue": "./src/modules/shop/src/views/ListCategory.vue",
	"./ListCostCentre.vue": "./src/modules/shop/src/views/ListCostCentre.vue",
	"./ListCustomerLocation.vue": "./src/modules/shop/src/views/ListCustomerLocation.vue",
	"./ListDelivery.vue": "./src/modules/shop/src/views/ListDelivery.vue",
	"./ListDeliveryDate.vue": "./src/modules/shop/src/views/ListDeliveryDate.vue",
	"./ListDivision.vue": "./src/modules/shop/src/views/ListDivision.vue",
	"./ListEmail.vue": "./src/modules/shop/src/views/ListEmail.vue",
	"./ListOrder.vue": "./src/modules/shop/src/views/ListOrder.vue",
	"./ListPickingList.vue": "./src/modules/shop/src/views/ListPickingList.vue",
	"./ListPickingListItem.vue": "./src/modules/shop/src/views/ListPickingListItem.vue",
	"./ListPreferredDeliveryAddress.vue": "./src/modules/shop/src/views/ListPreferredDeliveryAddress.vue",
	"./ListPurchaseLimit.vue": "./src/modules/shop/src/views/ListPurchaseLimit.vue",
	"./ListQuotes.vue": "./src/modules/shop/src/views/ListQuotes.vue",
	"./ListRestaurantAdmin.vue": "./src/modules/shop/src/views/ListRestaurantAdmin.vue",
	"./ListSalesOrder.vue": "./src/modules/shop/src/views/ListSalesOrder.vue",
	"./ListStockItem.vue": "./src/modules/shop/src/views/ListStockItem.vue",
	"./ListSupplier.vue": "./src/modules/shop/src/views/ListSupplier.vue",
	"./MyOrders.vue": "./src/modules/shop/src/views/MyOrders.vue",
	"./OrderConfirmed.vue": "./src/modules/shop/src/views/OrderConfirmed.vue",
	"./Orders.vue": "./src/modules/shop/src/views/Orders.vue",
	"./PickSalesOrder.vue": "./src/modules/shop/src/views/PickSalesOrder.vue",
	"./PickingList.vue": "./src/modules/shop/src/views/PickingList.vue",
	"./ProductRequest.vue": "./src/modules/shop/src/views/ProductRequest.vue",
	"./Quote.vue": "./src/modules/shop/src/views/Quote.vue",
	"./SalesDashboard.vue": "./src/modules/shop/src/views/SalesDashboard.vue",
	"./ShopCategories.vue": "./src/modules/shop/src/views/ShopCategories.vue",
	"./ShopCategoriesHorizontal.vue": "./src/modules/shop/src/views/ShopCategoriesHorizontal.vue",
	"./ShopHome.vue": "./src/modules/shop/src/views/ShopHome.vue",
	"./ShopSearch.vue": "./src/modules/shop/src/views/ShopSearch.vue",
	"./ShopStockItem.vue": "./src/modules/shop/src/views/ShopStockItem.vue",
	"./ShopStockItemByCategory.vue": "./src/modules/shop/src/views/ShopStockItemByCategory.vue",
	"./ShopStockItems.vue": "./src/modules/shop/src/views/ShopStockItems.vue",
	"./StockItemDetail.vue": "./src/modules/shop/src/views/StockItemDetail.vue",
	"./ViewSalesOrder.vue": "./src/modules/shop/src/views/ViewSalesOrder.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules/shop/src/views sync recursive \\.vue$";